import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import IDSTable from "./IDSTable";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import InputAdornment from "@mui/material/InputAdornment";
import Accordion from "react-bootstrap/Accordion";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { ERROR_MSG, S3_URL, TEST_RESULT_OPTIONS } from "../services/Constants";
import { snomedHeadCells } from "../util/headcells-util";
import {
  fetchSnomedData,
  addNewSnomed,
  updateSnomedRecord,
  removeSnomedRecord,
  fetchSnomedById,
} from "../services/snomedCodes-service";
import _ from "lodash";
import { handleIsActive } from "../util/common";
import { fetchConditions } from "../services/conditions-service";
import { fetchCodeSetTable } from "../services/referenceTable-service";
import { useContext } from "react";
import UserContext from "../context/user-context";
import { componentIsVisible, validateAndSanitizeUrl } from "../util/common";
import { STRB } from "../util/component-codes";
import { FixedSizeList } from "react-window";
import Cookies from "js-cookie";
import {
  addNewSnomedForIDSS,
  removeSnomedForIDSS,
  updateSnomedForIDSS,
} from "../services/ids-service";
import { Autocomplete, TextField } from "@mui/material";

const SNOMEDCodes = () => {
  const [show, setShow] = useState(false);
  const [alertMessage, setAlertMessage] = useState();
  const [showRemoveWarningModal, setShowRemoveWarningModal] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [form, setForm] = useState({});

  const [filter, setFilter] = useState({});
  const [isAddNew, setIsAddNew] = useState(false);

  const [validated, setValidated] = useState(false);
  const [isAdded, setIsAdded] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [snomedData, setSnomedData] = useState(null);
  const [modifiedRow, setModifiedRow] = useState(null);
  const [recordsPerPage, setRecordsPerPage] = useState(
    Cookies.get("itemsPerPage") ? Cookies.get("itemsPerPage") : 5
  );
  const [pageNo, setPageNo] = useState(0);
  const [isFetchError, setIsFetchError] = useState(false);
  const [isError, setIsError] = useState(false);
  const [conditions, setConditions] = useState([]);
  const [ordinalResultValues, setOrdinalResultValues] = useState([]);
  const [conditionCheckedValues, setConditionCheckedValues] = useState([]);
  const [ordinalResultCheckedValues, setOrdinalResultCheckedValues] = useState(
    []
  );
  const [isAcceptableByRE, setIsAcceptableByRE] = useState(false);
  const [selectedConditions, setSelectedConditions] = useState([]);

  const handleClose = () => setShow(false);
  const handleRemoveWarningModalClose = () => setShowRemoveWarningModal(false);
  const handleFilterModalClose = () => setShowFilterModal(false);

  const [user] = useContext(UserContext);

  const urlWithParams = (filter) => {
    let snomedCode = filter?.searchText ? filter?.searchText : "";
    let conditions = filter?.conditions?.length > 0 ? filter?.conditions : [];
    let snomedType = [];
    let codeSystem = [];
    let ordinalResult =
      filter?.ordinalResult?.length > 0 ? filter?.ordinalResult : [];
    let isActive = [];

    if (filter?.result) {
      snomedType.push("Ordinal Result");
    }
    if (filter?.organism) {
      snomedType.push("Organism");
    }
    if (filter?.condition) {
      snomedType.push("Condition");
    }
    if (filter?.snomed) {
      codeSystem.push("SNOMED");
    }
    if (filter?.plr) {
      codeSystem.push("PLR");
    }
    if (filter?.active) {
      isActive.push("true");
    }
    if (filter?.inactive) {
      isActive.push("false");
    }

    let params = "";

    if (snomedCode !== "") {
      params += `&snomedCode=${snomedCode}`;
    }
    if (conditions.length > 0) {
      params += `&condition=${conditions.toString()}`;
    }
    if (snomedType.length > 0) {
      params += `&snomedType=${snomedType.toString()}`;
    }
    if (codeSystem.length > 0) {
      params += `&codeSystem=${codeSystem.toString()}`;
    }
    if (ordinalResult.length > 0) {
      params += `&result=${ordinalResult.toString()}`;
    }
    if (isActive.length > 0) {
      params += `&isActive=${isActive.toString()}`;
    }

    return params;
  };

  const handleConditionCheckboxChange = (event) => {
    let copyCheckedValues = [...conditionCheckedValues];

    if (copyCheckedValues.includes(event.target.name)) {
      copyCheckedValues = copyCheckedValues.filter(
        (item) => item !== event.target.name
      );
    } else {
      copyCheckedValues = [...copyCheckedValues, event.target.name];
    }
    setConditionCheckedValues(copyCheckedValues);
    setFilterField("conditions", copyCheckedValues);
  };

  const handleOrdinalResultCheckboxChange = (event) => {
    let copyCheckedValues = [...ordinalResultCheckedValues];

    if (copyCheckedValues.includes(event.target.name)) {
      copyCheckedValues = copyCheckedValues.filter(
        (item) => item !== event.target.name
      );
    } else {
      copyCheckedValues = [...copyCheckedValues, event.target.name];
    }
    setOrdinalResultCheckedValues(copyCheckedValues);
    setFilterField("ordinalResult", copyCheckedValues);
  };

  const getSnomedData = useCallback(
    async (filter) => {
      let response = await fetchSnomedData(
        pageNo,
        recordsPerPage,
        urlWithParams(filter)
      );

      if (response.ok) {
        let data = await response.json();
        if (data.genericList != null) {
          setSnomedData(data);
        } else {
          setIsFetchError(true);
          let error = await response.json();
          setIsError(true);
          setAlertMessage(error?.description);
        }
      } else {
        let error = await response.json();
        setIsError(true);
        setAlertMessage(error?.description);
      }
    },
    [pageNo, recordsPerPage]
  );

  const addSnomed = async () => {
    if (form?.snomedType === "Ordinal Result") {
      form.isAcceptableByRE = true;
      form.conditionId = null;
    } else if (form?.snomedType === "Organism") {
      form.isAcceptableByRE = isAcceptableByRE;
      form.result = null;
      form.idssConditionIds = selectedConditions
        ? selectedConditions.map((v) => v?.conditionId).join(",")
        : "";
      form.idssConditionNames = selectedConditions
        ? selectedConditions.map((v) => v?.conditionName)
        : [""];
    } else {
      form.isAcceptableByRE = null;
      form.result = null;
    }
    //Call for IDS
    let data1 = await addNewSnomedForIDSS(form);
    console.log(data1);
    if (data1?.statusCode === "200") {
      let data = await addNewSnomed(form);
      if (data.snomedId != null) {
        setModifiedRow(data.snomedCode);
        setIsAdded(true);
      } else {
        setIsError(true);
        setAlertMessage(data?.description);
      }
    } else {
      setIsError(true);
      setAlertMessage(
        "Error, synchronization unsuccessful with IDSS SNOMED Table: " +
          data1?.message
      );
    }
  };

  const updateSnomed = async () => {
    if (form?.snomedType === "Ordinal Result") {
      form.isAcceptableByRE = true;
      form.conditionId = null;
    } else if (form?.snomedType === "Organism") {
      form.isAcceptableByRE = isAcceptableByRE;
      form.result = null;
      form.idssConditionIds = selectedConditions
        ? selectedConditions.map((v) => v?.conditionId).join(",")
        : "";
      form.idssConditionNames = selectedConditions
        ? selectedConditions.map((v) => v?.conditionName)
        : [""];
    } else {
      form.isAcceptableByRE = null;
      form.result = null;
    }
    let data1 = await updateSnomedForIDSS(form);
    console.log(data1);
    if (data1?.statusCode === "200") {
      let data = await updateSnomedRecord(form);
      if (data.snomedId != null) {
        setModifiedRow(data.snomedCode);
        setIsUpdated(true);
        setSelectedRow(data);
      } else {
        setIsError(true);
        setAlertMessage(data?.description);
      }
    } else {
      setIsError(true);
      setAlertMessage(
        "Error, synchronization unsuccessful with IDSS SNOMED Table: " +
          data1?.message
      );
    }
  };

  const removeSnomed = async () => {
    let data1 = await removeSnomedForIDSS(selectedRow.snomedCode);
    if (data1?.statusCode === "200") {
      let response = await removeSnomedRecord(selectedRow.snomedId);
      if (response !== ERROR_MSG) {
        setIsDeleted(true);
        setSelectedRow(null);
      } else {
        setIsError(true);
      }
    } else {
      setIsError(true);
      setAlertMessage(
        "Error, synchronization unsuccessful with IDSS SNOMED Table: " +
          data1?.message
      );
    }
    handleRemoveWarningModalClose();
  };

  const getConditions = async () => {
    let response = await fetchConditions();

    if (response.ok) {
      let data = await response.json();

      if (data?.length > 0) {
        setConditions(data);
      } else {
        setIsFetchError(true);
        let error = await response.json();
        setAlertMessage(error?.description);
      }
    } else {
      let error = await response.json();
      setIsFetchError(true);
      setAlertMessage(error?.description);
    }
  };

  const getOrdinalResultDropdownValues = async () => {
    let response = await fetchCodeSetTable("Ordinal Result");
    if (response.ok) {
      let data = await response.json();
      setOrdinalResultValues(data.refTableValues);
    }
  };

  useEffect(() => {
    getSnomedData(filter);
  }, [pageNo, recordsPerPage, getSnomedData]);

  useEffect(() => {
    if (isAdded || isUpdated || isDeleted) {
      getSnomedData(filter);
    }
  }, [isAdded, isUpdated, isDeleted, getSnomedData]);

  useEffect(() => {
    getConditions();
    getOrdinalResultDropdownValues();
  }, []);

  useEffect(() => {
    if (pageNo >= snomedData?.totalPages) {
      snomedData?.totalPages !== 0 && setPageNo(snomedData?.totalPages - 1);
    }
    // else setPageNo(0)
  }, [snomedData]);

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });
  };

  const setFilterField = (field, value) => {
    setFilter({
      ...filter,
      [field]: value,
    });
  };

  const handleAdd = () => {
    setForm({});
    setValidated(false);
    setIsAddNew(true);
    setShow(true);
    setIsAdded(false);
    setIsUpdated(false);
    setIsDeleted(false);
    setIsError(false);
  };

  const handleShowFilter = () => {
    setIsAdded(false);
    setIsUpdated(false);
    setIsDeleted(false);
    setIsError(false);
    setShowFilterModal(true);
  };

  const handleUpdate = async () => {
    let response = await fetchSnomedById(selectedRow.snomedId);
    if (response.ok) {
      let data = await response.json();
      if (data != null) {
        const idssConditionIdsArray = data?.idssConditionIds
          ?.split(",")
          ?.map(Number);
        conditions.length > 0 &&
          setSelectedConditions(
            conditions.filter((item) =>
              idssConditionIdsArray?.includes(item.conditionId)
            )
          );
        setIsAcceptableByRE(data.isAcceptableByRE);
        setForm(data);
        setValidated(false);
        setIsAddNew(false);
        setShow(true);
        setIsUpdated(false);
        setIsAdded(false);
        setIsDeleted(false);
        setIsError(false);
      }
    } else {
      let error = await response.json();
      setIsError(true);
      setAlertMessage(error?.description);
    }
  };

  const handleRemove = () => {
    setShowRemoveWarningModal(true);
    setIsUpdated(false);
    setIsAdded(false);
    setIsDeleted(false);
    setIsError(false);
  };

  const handleSubmmit = (event) => {
    event.preventDefault();
    setValidated(true);
    if (event.currentTarget.checkValidity() === true) {
      //Call for IDS

      isAddNew ? addSnomed() : updateSnomed();
      setShow(false);
    }
  };

  const handleFilter = (event) => {
    event.preventDefault();
    setPageNo(0);
    pageNo === 0 && getSnomedData(filter);
    handleFilterModalClose();
  };

  const handleResetFilter = () => {
    setConditionCheckedValues([]);
    setOrdinalResultCheckedValues([]);
    setFilter({});
  };

  const setSelectedRowCallback = (row) => {
    setSelectedRow(row);
  };

  const setRecordsPerPageCallback = (value) => {
    setRecordsPerPage(value);
  };

  const setPageNoCallback = (value) => {
    setPageNo(value);
  };

  const buttonsLayout = () => {
    return (
      <div className="flexCenter">
        <Button
          className="updateButtonStyle generalFont flexCenter"
          onClick={handleUpdate}
          disabled={selectedRow == null && !isError}
        >
          <img
            src={`${validateAndSanitizeUrl(S3_URL)}update-icon.png`}
            className="buttonIcon"
            alt=""
          ></img>
          Update
        </Button>
        {componentIsVisible(STRB, user) && (
          <Button
            className="removeButtonStyle generalFont flexCenter"
            onClick={handleRemove}
            disabled={selectedRow == null && !isError}
          >
            <img
              src={`${validateAndSanitizeUrl(S3_URL)}delete-icon.png`}
              className="buttonIcon"
              alt=""
            ></img>
            Remove
          </Button>
        )}
      </div>
    );
  };

  const renderBannerMessage = () => {
    if (isDeleted) {
      return "Successfully deleted SNOMED record";
    } else if (isAdded) {
      return (
        "New SNOMED code : " + modifiedRow + " has been successfully added!"
      );
    } else if (isUpdated) {
      return "SNOMED code : " + modifiedRow + " has been successfully updated!";
    } else if (isError) {
      return alertMessage
        ? alertMessage
        : "Something went wrong, please try again";
    }
  };

  const setExpandedAccordion = () => {
    let active = [];
    if (conditionCheckedValues.length > 0) {
      active.push("0");
    }
    if (filter?.result || filter?.organism) {
      active.push("1");
    }
    if (filter?.snomed || filter?.plr) {
      active.push("2");
    }
    if (ordinalResultCheckedValues.length > 0) {
      active.push("3");
    }
    if (filter?.active || filter?.inactive) {
      active.push("4");
    }
    return active;
  };

  const updateSnomedType = (value) => {
    value === "Condition"
      ? setForm({
          ...form,
          testResultInterpretation: "Positive",
          snomedType: value,
        })
      : setForm({
          ...form,
          testResultInterpretation: "",
          snomedType: value,
        });

    setIsAcceptableByRE(false);
    setSelectedConditions([]);
  };

  return (
    <>
      <Container fluid className="loincContainer">
        <Row style={{ marginLeft: "0px" }}>
          <Col xl={8}>
            <Row className="tableTitle generalFont">SNOMED Table</Row>
            <Row className="tableSubtitle generalFont">
              View all the SNOMED codes available to you
            </Row>
          </Col>
        </Row>
        {(isAdded || isUpdated || isDeleted || isError) && (
          <Alert
            style={{ marginRight: "125px" }}
            key={"success"}
            variant={isError ? "danger" : "success"}
            onClose={() => {
              setIsAdded(false);
              setIsUpdated(false);
              setIsDeleted(false);
              setIsError(false);
            }}
            dismissible
          >
            {renderBannerMessage()}
          </Alert>
        )}

        <IDSTable
          isFetchError={isFetchError}
          setPageNoCallback={setPageNoCallback}
          setRecordsPerPageCallback={setRecordsPerPageCallback}
          headCells={snomedHeadCells}
          rows={snomedData?.genericList}
          pages={snomedData?.totalPages}
          buttonsLayout={buttonsLayout}
          addButtonName="Add New SNOMED"
          addButtonAction={handleAdd}
          closeButtonAction={handleClose}
          setSelectedRowCallback={setSelectedRowCallback}
          handleShowFilter={handleShowFilter}
          isSnomedTable={true}
        />
      </Container>

      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Form onSubmit={handleSubmmit} noValidate validated={validated}>
          <Modal.Header className="modalHeaderContainer" closeButton>
            <Modal.Title className="modalHeader generalFont">
              {isAddNew ? "Add New SNOMED" : "Update SNOMED"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="modalBodyContainer">
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="form.snomedCode">
                  <React.Fragment>
                    <Form.Label className="modalLabel generalFont">
                      SNOMED Code <i className="text-danger">(required)</i>
                    </Form.Label>
                  </React.Fragment>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    placeholder="Hint Text"
                    required
                    value={form.snomedCode}
                    onChange={(e) => setField("snomedCode", e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="form.secondarySnomed">
                  <React.Fragment>
                    <Form.Label className="modalLabel generalFont">
                      Secondary SNOMED
                    </Form.Label>
                  </React.Fragment>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    placeholder="Hint Text"
                    value={form.secondarySnomed}
                    onChange={(e) =>
                      setField("secondarySnomed", e.target.value)
                    }
                  />
                </Form.Group>
              </Col>{" "}
              <Col>
                <Form.Group className="mb-3" controlId="form.snomedType">
                  <Form.Label className="modalLabel generalFont">
                    SNOMED Type <i className="text-danger">(required)</i>
                  </Form.Label>
                  <Form.Select
                    className="modalInput generalFont"
                    aria-label="Choose Item"
                    required
                    value={form.snomedType}
                    onChange={(e) => updateSnomedType(e.target.value)}
                    feedback="You must agree before submitting."
                  >
                    <option hidden value="">
                      Choose Item
                    </option>
                    <option value="Ordinal Result">Ordinal Result</option>
                    <option value="Organism">Organism</option>
                    <option value="Condition">Condition</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            {form?.snomedType === "Organism" && (
              <Form.Check
                className="modalLabel generalFont"
                style={{ marginTop: "15px", marginBottom: "20px" }}
                name="lookUp"
                value={isAcceptableByRE}
                type="checkbox"
                label="Acceptable by Rules Engine"
                inline
                onChange={(e) => {
                  setIsAcceptableByRE(!isAcceptableByRE);
                }}
                checked={isAcceptableByRE}
              />
            )}
            <Form.Group className="mb-3" controlId="form.result">
              <Form.Label className="modalLabel generalFont">
                Ordinal Result
                {form?.snomedType === "Ordinal Result" && (
                  <i className="text-danger"> (required)</i>
                )}
              </Form.Label>
              <Form.Select
                className="modalInput generalFont"
                aria-label="Choose Item"
                required={form?.snomedType === "Ordinal Result"}
                disabled={form?.snomedType !== "Ordinal Result"}
                value={form.snomedType === "Ordinal Result" ? form.result : ""}
                onChange={(e) => setField("result", e.target.value)}
                feedback="You must agree before submitting."
              >
                <option hidden value="">
                  Choose Item
                </option>
                {_.sortBy(ordinalResultValues, [
                  "reference_Code_description",
                ]).map((entry) => {
                  return (
                    <option
                      key={entry.referenceTableValueId}
                      value={entry.reference_Code_description}
                    >
                      {entry.reference_Code_description}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="form.testResultInterpretation"
            >
              <Form.Label className="modalLabel generalFont">
                Test Result Interpretation (Business Rules)
              </Form.Label>
              <Form.Select
                className="modalInput generalFont"
                aria-label="Choose Item"
                value={form.testResultInterpretation}
                disabled={form?.snomedType === "Condition"}
                onChange={(e) =>
                  setField("testResultInterpretation", e.target.value)
                }
              >
                <option value="">Choose Item</option>
                {TEST_RESULT_OPTIONS.sort((a, b) => (a > b ? 1 : -1)).map(
                  (entry) => {
                    return (
                      <option key={entry} value={entry}>
                        {entry}
                      </option>
                    );
                  }
                )}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3" controlId="form.conceptName">
              <Form.Label className="modalLabel generalFont">
                Preferred concept name <i className="text-danger">(required)</i>
              </Form.Label>
              <Form.Control
                className="modalInput generalFont"
                type="text"
                placeholder="Hint Text"
                required
                value={form.conceptName}
                onChange={(e) => setField("conceptName", e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="form.conditionId">
                  <Form.Label className="modalLabel generalFont">
                    Condition{" "}
                    {form?.snomedType === "Organism" && (
                      <i className="text-danger">(required)</i>
                    )}
                    {form?.snomedType === "Condition" && (
                      <i className="text-danger">(required)</i>
                    )}
                  </Form.Label>
                  <Form.Select
                    className="modalInput generalFont"
                    aria-label="Choose Item"
                    required={
                      form?.snomedType === "Organism" ||
                      form?.snomedType === "Condition"
                    }
                    disabled={
                      form?.snomedType !== "Organism" &&
                      form?.snomedType !== "Condition"
                    }
                    value={
                      form.snomedType === "Organism" ||
                      form?.snomedType === "Condition"
                        ? form.conditionId
                        : ""
                    }
                    onChange={(e) => {
                      let condition = conditions.find(
                        (item) =>
                          item.conditionId?.toString() ===
                          e.target.value?.toString()
                      );
                      setSelectedConditions([condition]);
                      setField("conditionId", e.target.value);
                    }}
                    feedback="You must agree before submitting."
                  >
                    <option hidden value="">
                      Choose Item
                    </option>
                    {conditions
                      .sort((a, b) =>
                        a.conditionName > b.conditionName ? 1 : -1
                      )
                      .map((entry) => {
                        return (
                          <option
                            key={entry.conditionId}
                            value={entry.conditionId}
                          >
                            {entry.conditionName}
                          </option>
                        );
                      })}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="form.codeSystem">
                  <Form.Label className="modalLabel generalFont">
                    Code System <i className="text-danger">(required)</i>
                  </Form.Label>
                  <Form.Select
                    className="modalInput generalFont"
                    aria-label="Choose Item"
                    required
                    value={form.codeSystem}
                    onChange={(e) => setField("codeSystem", e.target.value)}
                  >
                    <option hidden value="">
                      Choose Item
                    </option>
                    <option value="SNOMED">SNOMED</option>
                    <option value="PLR">PLR</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            {form?.snomedType === "Organism" && (
              <Row>
                <Col>
                  <Form.Group className="mb-3" controlId="form.conditionId">
                    <Form.Label className="modalLabel generalFont">
                      Conditions for Dropdown Values in IDSS{" "}
                    </Form.Label>
                    {conditions && (
                      <Autocomplete
                        multiple
                        id="tags-standard"
                        options={conditions.sort(
                          (a, b) =>
                            -b.conditionName.localeCompare(a.conditionName)
                        )}
                        getOptionLabel={(option) => {
                          return option?.conditionName?.trim();
                        }}
                        value={selectedConditions ? selectedConditions : []}
                        onChange={(event, newValue) => {
                          setSelectedConditions(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            placeholder="Search Condition"
                          />
                        )}
                        sx={{
                          width: "96%",
                        }}
                      />
                    )}
                  </Form.Group>
                </Col>
              </Row>
            )}

            <Row>
              <Col>
                {" "}
                <Form.Group className="mb-3" controlId="form.isActive">
                  <Form.Label className="modalLabel generalFont">
                    Status <i className="text-danger">(required)</i>
                  </Form.Label>
                  <Form.Select
                    className="modalInput generalFont"
                    aria-label="Choose Item"
                    required
                    value={handleIsActive(form.isActive)}
                    onChange={(e) =>
                      setField(
                        "isActive",
                        e.target.value === "Active" ? true : false
                      )
                    }
                  >
                    <option hidden value="">
                      Choose Item
                    </option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col></Col>
            </Row>
            <Form.Group className="mb-3" controlId="form.comments">
              <Form.Label className="modalLabel generalFont">
                Admin Comments
              </Form.Label>
              <Form.Control
                className="modalInput generalFont"
                as="textarea"
                rows={3}
                value={form.comments ? form.comments : ""}
                onChange={(e) => setField("comments", e.target.value)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="modalFooterContainer">
            <Button
              type="submit"
              className="modalAddUpdateStyle generalFont flexCenter"
            >
              <img
                src={`${validateAndSanitizeUrl(S3_URL)}plus-icon.png`}
                alt=""
                style={{ marginRight: "10px" }}
              ></img>
              {isAddNew ? "Add" : "Update"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal
        show={showRemoveWarningModal}
        onHide={handleRemoveWarningModalClose}
        size="lg"
        centered
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Remove SNOMED
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              Are you sure you want to remove this SNOMED Code from the Table?
              <br />
              <br />
              The SNOMED will no longer be visible on the screen and all
              rules/conditions associated with this SNOMED will also be deleted
            </Form.Label>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer className="modalFooterContainer">
          <Button
            onClick={handleRemoveWarningModalClose}
            className="modalCancelStyle generalFont flexCenter"
            variant="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={removeSnomed}
            className="modalRemoveStyle generalFont flexCenter"
          >
            Remove
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showFilterModal}
        onHide={handleFilterModalClose}
        size="sm"
        centered
        dialogClassName="my-modal-30"
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Apply Filters
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Search SNOMED"
                value={filter.searchText ? filter.searchText : ""}
                onChange={(e) => setFilterField("searchText", e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br />
            <br />
            <Accordion
              alwaysOpen
              disablegutters="true"
              defaultActiveKey={setExpandedAccordion()}
            >
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div className="bold">Conditions</div>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    maxHeight: "200px",
                    overflow: "hidden",
                  }}
                >
                  <FormGroup>
                    <FixedSizeList
                      height={200}
                      itemSize={40}
                      itemCount={
                        conditions.sort((a, b) =>
                          a.conditionName.localeCompare(b.conditionName)
                        ).length
                      }
                    >
                      {({ index, style }) => (
                        <div style={style}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={conditionCheckedValues.includes(
                                  conditions[index].conditionName
                                )}
                                onChange={handleConditionCheckboxChange}
                                name={conditions[index].conditionName}
                              />
                            }
                            label={conditions[index].conditionName}
                          />
                        </div>
                      )}
                    </FixedSizeList>
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
              <br />
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <div className="bold">SNOMED Type</div>
                </Accordion.Header>
                <Accordion.Body>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Ordinal Result"
                      checked={filter.result ? true : false}
                      onChange={(e) =>
                        setFilterField("result", e.target.checked)
                      }
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Organism"
                      checked={filter.organism ? true : false}
                      onChange={(e) =>
                        setFilterField("organism", e.target.checked)
                      }
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Condition"
                      checked={filter.condition ? true : false}
                      onChange={(e) =>
                        setFilterField("condition", e.target.checked)
                      }
                    />
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
              <br />
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  <div className="bold">Code System</div>
                </Accordion.Header>
                <Accordion.Body>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label="SNOMED"
                      checked={filter.snomed ? true : false}
                      onChange={(e) =>
                        setFilterField("snomed", e.target.checked)
                      }
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="PLR"
                      checked={filter.plr ? true : false}
                      onChange={(e) => setFilterField("plr", e.target.checked)}
                    />
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
              <br />
              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  <div className="bold">Ordinal Results</div>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    maxHeight: "200px",
                    overflow: "hidden",
                  }}
                >
                  <FormGroup>
                    <FixedSizeList
                      height={200}
                      itemSize={40}
                      itemCount={
                        ordinalResultValues.sort((a, b) =>
                          a.reference_Code_description.localeCompare(
                            b.reference_Code_description
                          )
                        ).length
                      }
                    >
                      {({ index, style }) => (
                        <div style={style}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={ordinalResultCheckedValues.includes(
                                  ordinalResultValues[index]
                                    .reference_Code_description
                                )}
                                onChange={handleOrdinalResultCheckboxChange}
                                name={
                                  ordinalResultValues[index]
                                    .reference_Code_description
                                }
                              />
                            }
                            label={
                              ordinalResultValues[index]
                                .reference_Code_description
                            }
                          />
                        </div>
                      )}
                    </FixedSizeList>
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
              <br />
              <Accordion.Item eventKey="4">
                <Accordion.Header>
                  <div className="bold">Status</div>
                </Accordion.Header>
                <Accordion.Body>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Active"
                      checked={filter.active ? true : false}
                      onChange={(e) =>
                        setFilterField("active", e.target.checked)
                      }
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Inactive"
                      checked={filter.inactive ? true : false}
                      onChange={(e) =>
                        setFilterField("inactive", e.target.checked)
                      }
                    />
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer
          className="modalFooterContainer"
          style={{ justifyContent: "space-between", marginLeft: "23px" }}
        >
          <Button
            onClick={handleResetFilter}
            className="modalAddUpdateStyle generalFont flexCenter modalRemoveStyle"
          >
            Reset
          </Button>
          <Button
            onClick={handleFilter}
            className="modalAddUpdateStyle generalFont flexCenter"
          >
            Filter
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SNOMEDCodes;
